import AnalysisSalesScheduleActions from './actions';

const INITIAL_STATE = {
  data: {},
  dataTracking: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  helperAnalysisSalesSchedule:null,
  timeline:null,
  details:null,
  loadingDetails:false
};

function AnalysisSalesScheduleReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AnalysisSalesScheduleActions.RESET_DATA:
      return INITIAL_STATE;
    case AnalysisSalesScheduleActions.NEW_DATA:
      return { ...state, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case AnalysisSalesScheduleActions.GET_HELPER_REPORTVISIT:
        return { 
          ...state,
          isProcessing: false, 
          helperAnalysisSalesSchedule: action.payload 
        };
      case AnalysisSalesScheduleActions.GET_DATA:
        return { 
          ...state,
          isError: false,
          isProcessing: true, 
      };
      case AnalysisSalesScheduleActions.SHOW_DATA:
        return { 
          ...state,
          isProcessing: false, 
          isError: false,
          data: action.payload 
        };
      case AnalysisSalesScheduleActions.ERROR_DATA:
          return { 
            ...state, errorInternal:false, 
            isError: true,onSubmit:false,  
            errorMessage: action.payload,
            isProcessing:false 
        };
      case AnalysisSalesScheduleActions.LOADED_DETAILS:
        return { 
          ...state,
          details: action.payload, 
          loadingDetails: false
        };
      case AnalysisSalesScheduleActions.LOADING_DETAILS:
        return { 
          ...state,
          details: null, 
          loadingDetails: true
        };
    default:
      return state;
    }
}


export default AnalysisSalesScheduleReducer;
